"use client";

import styles from "./VerificationContent.module.scss";
import { ReactNode } from "react";

/**
 * VerificationContent Component
 *
 * Main verification content component.
 * Handles verification flow for new users.
 */
export const VerificationContent = ({ children }: { children: ReactNode }) => {
  return <div className={styles["comp"]}>{children}</div>;
};
